module.exports = __webpack_public_path__ + "img/index1.06576e1a.png";